import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  ProductPod,
  ProductImage,
  ProductIdentifier,
  ProductRating,
  PodTapper
} from '@thd-olt-component-react/product-pod';
import {
  bool as boolType,
  string as stringType,
  number as numType
} from 'prop-types';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';

export const DiscoveryZonesPod = (props) => {
  const {
    // eslint-disable-next-line react/prop-types
    itemId,
    storeId,
    position,
    parent,
    scheme,
    anchorProduct,
    brandTitleMaxLine,
    zoneName,
    zonePosition,
    podResults,
    hideRatings,
    url
  } = props;

  const handleClick = () => {

    const productPodEventData = {
      podAction: 'product pod',
      podAnchorSku: itemId,
      target: '_self',
      parent
    };
    window.LIFE_CYCLE_EVENT_BUS.trigger('product-pod-v7.click', productPodEventData);
  };

  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{
        parent, position, scheme, anchorProduct, zoneName, zonePosition, podResults
      }}
      padding="sui-p-2"
      render={(pod) => (
        <>
          <a
            className="sui-top-0 sui-left-0 sui-absolute sui-size-full sui-z-1"
            href={url}
            aria-label="Link"
            onClick={handleClick}
          />
          <PodTapper zIndex>
            <ProductImage
              itemId={pod.itemId}
              showSecondaryImage={pod.showSecondaryImage}
              onClick={() => { }}
            />
          </PodTapper>
          <PodTapper fitWidth zIndex>
            <ProductHeader
              brand="inline"
              brandFontSize="sm"
              itemId={pod.itemId}
              brandTitleMaxLine={brandTitleMaxLine}
              disableShopThisCollection
              productNameLineHeight="tight"
            />
          </PodTapper>

          {!hideRatings
          && (
            <PodTapper fitWidth zIndex>
              <ProductRating itemId={pod.itemId} />
            </PodTapper>
          )}
          <PodTapper zIndex pointerNone aPointer buttonPointer spanPointer>
            <Price
              itemId={pod.itemId}
              large={false}
              storeId={storeId}
              displayEachUom={false}
              showPreferredPricingBadge
            />
          </PodTapper>
        </>
      )}
    />
  );
};

DiscoveryZonesPod.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductIdentifier,
  ProductHeader,
  SuperSkuMiniSwatches,
  Price,
  ProductRating
);

DiscoveryZonesPod.propTypes = {
  storeId: stringType,
  position: numType,
  parent: stringType,
  scheme: stringType,
  anchorProduct: stringType,
  brandTitleMaxLine: numType,
  zoneName: stringType,
  zonePosition: stringType,
  podResults: numType,
  hideRatings: boolType,
  url: stringType.isRequired
};

DiscoveryZonesPod.defaultProps = {
  storeId: '',
  position: '',
  parent: '',
  scheme: 'drecs',
  anchorProduct: '',
  brandTitleMaxLine: 4,
  zoneName: '',
  zonePosition: '',
  podResults: 0,
  hideRatings: false
};
DiscoveryZonesPod.displayName = 'DiscoveryZonesPod';
